export const EASE_IN_OUT = 'cubic-bezier(0.37, 0, 0.63, 1)';
export const DEFAULT_COLOR = '#1e1e1e';
export const OFFSET_ERROR = 5;
